
import { Topic } from '@/components/TopicSelector';

export const topics: Topic[] = [
  {
    id: 'fiqh101',
    title: 'Fiqh 101',
    arabicTitle: 'الفِقْه',
    description: 'Learn the foundational principles of Islamic jurisprudence, including definitions, sources, key concepts, and their historical development.',
    questionCount: 30 // Limiting to 30 questions per session for better learning retention
  },
  {
    id: 'qur101',
    title: 'Qur\'ān 101',
    arabicTitle: 'علوم القرآن',
    description: 'Explore the sciences of the Qur\'ān (ʿUlūm al-Qur\'ān), including revelation, preservation, interpretation, and historical context.',
    questionCount: 30 // Limiting to 30 questions per session for better learning retention
  },
  {
    id: 'taj101',
    title: 'Tajweed 101',
    arabicTitle: 'التَّجْوِيْد',
    description: 'Master the rules of Quranic recitation (Tajweed), including proper pronunciation, articulation points, and characteristics of letters.',
    questionCount: 30 // Limiting to 30 questions per session for better learning retention
  }
];
